import { useContext } from "react";
import { SnackbarContext } from "../context/snackbar";

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;
